import { useSelector } from 'react-redux';
import { AppStateData } from '../reducers/appStateSlice/appStateSlice';

const useAppStateData = (): AppStateData => {
    return useSelector(({ appState }: PersistedStore) => appState);
};

export default useAppStateData;
